import React from 'react';
import { CHECKOUT_URL } from '../data/oferta';
const CIERRE_IMAGE = 'https://cdn.magicpatterns.com/uploads/dhvC6v1VUxDeyKRuLGrTNX/ChatGPT_Image_15_sept_2026,_11_41_39.png';
export function CierreSection() {
  return <section aria-label="Cierre e inscripción" className="bg-violet" data-id="element-1" data-mp="sgm95u1dlcq3">
      <img src={CIERRE_IMAGE} alt="Del dolor a la libertad emocional: autoconocimiento, herramientas y resultados." className="w-full border-y border-violet-line/60" width={1944} height={816} loading="lazy" data-id="element-2" data-mp="xh07gkd6d8ax" />

      <div className="mx-auto max-w-3xl px-6 py-24 text-center sm:py-28 lg:px-8" data-id="element-3" data-mp="17cjzgvombmue">
        <p className="font-serif text-3xl font-light leading-snug text-bone sm:text-[2.5rem]" data-id="element-4" data-mp="1c66fmxtzq8uy">
          No llegaste a esta página por casualidad. Si sientes que es momento de
          dejar de repetir la misma historia,{' '}
          <span className="text-gold" data-id="element-5" data-mp="1q55s7748axar">este es tu primer paso.</span>
        </p>

        <a href={CHECKOUT_URL} className="mt-12 inline-block rounded-full bg-gold px-10 py-5 font-sans text-base font-semibold tracking-wide text-violet-deep transition-colors duration-200 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-violet sm:text-lg" data-id="element-6" data-mp="1q31q8upw48d4">
          Sí, quiero recuperarme con poder
        </a>
      </div>
    </section>;
}